import { ChecklistItem } from '@/src/common/modules/OnboardingChecklist/ChecklistItem'

export function ExclusePointsCategoriesChecklistItem() {
  return (
    <>
      <ChecklistItem
        title="Earn 3X Points on all Home Related Purchases"
        description={`• Home improvement expenses\n• Utilities: heat, gas, electric, cable/internet\n• Home maintenance: cleaning, lawn care,\n    pest prevention and more\n• Decor & Furniture\n• Insurance & Taxes\n• Daycare`}
        status="complete"
      />
      <ChecklistItem
        title="Earn 2X points with Mesa"
        description={`• Earn 2X points on Grocery and Gas\n• Earn 1X points on all other purchases`}
        status="complete"
      />
    </>
  )
}
